export default class kvSlider {
    constructor(effect) {
        this.status = {
            slide: {
                current: 0,
                prevCurrent: 0,
                motion: false,
                slideTime: 0,
                max: 3,

            },
            mouseEnter:false
        }

        this.effect = effect
        this.scroll

        this.$slider
        this.$sliderList
        this.$sliderNum
        this.$sliderName

        this.$kv

    }
    init(scroll, mouse) {

        this.scroll = scroll;

        this.$slider = document.getElementById('p-kv-slider')
        this.$sliderList = this.$slider.querySelectorAll(
            '.slide-image-ref'
        )
        this.$sliderNum = this.$slider.querySelector(
            '.current-slide .current'
        )

        this.$sliderName = document.querySelectorAll(
            '.slider-name .text'
        )

        this.$kv = document.querySelector(
            '#top .kv'
        )

        this.$slider.querySelector(".slider-btn .arrow-right").addEventListener('click', e => {
            this.status.slide.current =
                this.$sliderList['length'] - 1 >
                this.status.slide.current
                    ? this.status.slide.current + 1
                    : 0

            if (
                this.status.slide.current ==
                this.status.slide.prevCurrent
            )
                return

            if(Useragnt.pc){
                this.scroll.nowInc = Math.round(this.scroll.nowInc)
                this.scroll.$body.style.transform = 'translateY(-'+ this.scroll.nowInc +'px)'
            }

            this.next();

            return false

        })
        this.$slider.querySelector(".slider-btn .arrow-left").addEventListener('click', e => {
            this.status.slide.current =
                0 < this.status.slide.current
                    ? this.status.slide.current - 1
                    : this.$sliderList['length'] - 1

            if (
                this.status.slide.current ==
                this.status.slide.prevCurrent
            )
                return

            if(Useragnt.pc){
                this.scroll.nowInc = Math.round(this.scroll.nowInc)
                this.scroll.$body.style.transform = 'translateY(-'+ this.scroll.nowInc +'px)'
            }

            this.prev();

            return false
        })

        TweenMax.set(
            document.querySelectorAll('.js__write'),
            {
                drawSVG: '0%',
            },
        )


        this.$slider.querySelector(".slider-btn .arrow-right").addEventListener('mousemove', e => {
            console.log("enter")
            if(this.status.mouseEnter) return;
            this.status.mouseEnter = true;
            this._sliderCtrlMouseEnter(e.target)
        })
        this.$slider.querySelector(".slider-btn .arrow-left").addEventListener('mousemove', e => {
            if(this.status.mouseEnter) return;
            this.status.mouseEnter = true;
            this._sliderCtrlMouseEnter(e.target)
        })

        this.$slider.querySelector(".slider-btn .arrow-right").addEventListener('mouseleave', e => {
            if(!this.status.mouseEnter) return;
            this.status.mouseEnter = false;
            this._sliderCtrlMouseLeave(e.target)
        })
        this.$slider.querySelector(".slider-btn .arrow-left").addEventListener('mouseleave', e => {
            if(!this.status.mouseEnter) return;
            this.status.mouseEnter = false;
            this._sliderCtrlMouseLeave(e.target)
        })


        this.resize(window.innerWidth,window.innerHeight);


        // this.effect.svg(document.querySelectorAll('.js__svg'), 'set')
        // this.effect.show(document.querySelectorAll('.js__show'), 'set')
    }
    next(){

        this.status.slide.slideTime = 0;
        this.status.slide.motion = true;

        this.$sliderList[this.status.slide.current].classList.add("is-current")
        this.$sliderList[this.status.slide.prevCurrent].classList.remove("is-current")
        this.status.slide.prevCurrent = this.status.slide.current

        this._sliderNumUpdate()

        TweenMax.to(this.$sliderList, 1.4, {
            opacity: 0,
            ease: Power2.easeOut
        })
        TweenMax.to(this.$sliderList[this.status.slide.current], 1.4, {
            opacity: 1,
            ease: Power2.easeOut,
            onComplete: () => {
                this.status.slide.motion = false;
            }
        })
        TweenMax.fromTo(
            this.$sliderList[this.status.slide.current].querySelector('.image'),
            1.2,
            {
                scale: 1.04
            },
            {
                scale: 1,
                ease: Power2.easeOut
            }
        )
    }
    prev(){

        this.status.slide.slideTime = 0;
        this.status.slide.motion = true;

        this.$sliderList[this.status.slide.prevCurrent].classList.remove("is-current")
        this.$sliderList[this.status.slide.current].classList.add("is-current")
        this.status.slide.prevCurrent = this.status.slide.current

        this._sliderNumUpdate(this.status.slide.current)

        for (let i in this.$sliderList) {
            if (this.$sliderList[i].nodeType != 1) break

            if(i == this.status.slide.current){
                TweenMax.to(this.$sliderList[i], 1.4, {
                    opacity: 1,
                    ease: Power2.easeOut
                })
                TweenMax.fromTo(
                    this.$sliderList[i].querySelector('.image'),
                    1.2,
                    {
                        scale: 1.04
                    },
                    {
                        scale: 1,
                        ease: Power2.easeOut
                    }
                )
            }else{
                TweenMax.to(this.$sliderList[i], 1.4, {
                    opacity: 0,
                    ease: Power2.easeOut,
                    onComplete: () => {
                        this.status.slide.motion = false;
                    }
                })
                TweenMax.to(
                    this.$sliderList[i].querySelector('.image'),
                    1.2,
                    {
                        scale: 1.04,
                        ease: Power2.easeOut
                    }
                )
            }
        }
    }
    resize(w, h, deviceSize) {}
    _sliderNumUpdate() {
        TweenMax.to(this.$sliderNum, 0.4, {
            y: -110 + '%',
            ease: Power2.easeOut,
            onComplete: () => {
                TweenMax.set(this.$sliderNum, { y: 110 + '%' })

                this.$sliderNum.textContent =
                    '0' + (this.status.slide.current + 1)

                TweenMax.to(this.$sliderNum, 0.4, {
                    y: 0 + '%',
                    ease: Power2.easeOut,
                })
            },
        })
        for (let i in this.$sliderName) {
            if (this.$sliderName[i].nodeType != 1) break
            if(i == this.status.slide.current){
                TweenMax.killTweensOf(this.$sliderName[i]);
                TweenMax.to(this.$sliderName[i], 1.1, {
                    delay: .5,
                    opacity: 1,
                    ease: Power2.easeOut
                })
            }else{
                TweenMax.killTweensOf(this.$sliderName[i]);
                TweenMax.to(this.$sliderName[i], 1.1, {
                    opacity: 0,
                    ease: Power2.easeOut
                })
            }
        }
    }
    _sliderCtrlMouseEnter($t){


        TweenMax.to(
            $t.querySelectorAll('.js__write'),
            0.4,
            {
                drawSVG: '100%',
                ease: Power2.easeIn,
                onComplete:()=>{
                }

            }
        )

    }
    _sliderCtrlMouseLeave($t){
        TweenMax.to(
            $t.querySelectorAll('.js__write'),
            0.4,
            {
                drawSVG: '0%',
                ease: Power2.easeIn,
            },
        )

    }
    render(modalMode){

        if(this.status.slide.motion||modalMode!="close") return;

        this.status.slide.slideTime = Number(this.status.slide.slideTime) + 1;
        if(this.status.slide.slideTime == 280){
            if(this.status.slide.prevCurrent == this.status.slide.max){
                this.status.slide.current = 0;
            }else{
                this.status.slide.current = Number(this.status.slide.prevCurrent) + 1;
            }
            this.next()
        }
    }
}